import { endpoint } from '@root/Services/Router/EndpointRegistry';
import '@root/Components/Resources/resources.scss';
import { AwsResourceDetailsTabs } from '@root/Components/Resources/Aws/AwsResourceDetailsTabs';

export function AwsResourcesLanding(props: { resourceType: string; resourceId: string }) {
    var resourceType = props.resourceType;
    var resourceId = props.resourceId;

    return (
        <div className="resourcesContainer">
            <AwsResourceDetailsTabs resourceType={resourceType} resourceId={resourceId} />
        </div>
    );
}

endpoint('aws', AwsResourcesLanding, 'Aws Resources');
